<template>
  <graph-detail06-template
    :com-group-list="comGroupList"
    :board-ids="[107]"
    field-code="facility"
    graph1-title="전체 (시설물)안전·보건 교육 현황"
    graph2-title="월별 (시설물)안전·보건 교육 현황"
    graph3-title="기간별 (시설물)안전·보건 교육 현황"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail06Template from "@/views/graph-detail/GraphDetail06Template.vue";

export default {
  name: "GraphDetail77",
  components: {
    GraphDetail06Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
